module.exports = __webpack_public_path__ + "img/logo-hotel-bialy-kamien.b37ad361.png";